import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from '../../../../components/Wrappers/Wrappers';
import CtaButton from '../../../../commons/ctaButton';
import { useStyles } from './heroSection.styles';

function ConnectHero ({ showPricing = true, onViewPricing, onBrowseIntegrations }) {
    const classes = useStyles();

    return (
        <div className={classes.hero}>
            <Typography variant="caption" weight="bold" className={classes.eyebrow}>
                {'DATA & ANALYTICS · CONNECT'}
            </Typography>

            <Typography variant="h3" weight="bold" className={classes.headline} style={{ fontSize: 36 }}>
                Your ECAL audience, flowing to the platforms, systems and tools you already use.
            </Typography>

            <Typography variant="body1" className={classes.intro}>
                Directly connect your ECAL audience data to over 50 popular data, mail, marketing, CDP,
                CRM, productivity and AI platforms. Unlimited integrations. Regular, frequent sync.
                Simple monthly billing. Connect in minutes.
            </Typography>

            <div className={classes.ctaRow}>
                <CtaButton kind="primary" onClick={onBrowseIntegrations}>
                    BROWSE INTEGRATIONS
                </CtaButton>
                {showPricing && (
                    <CtaButton kind="secondary" onClick={onViewPricing}>
                        VIEW PRICING
                    </CtaButton>
                )}
            </div>

            <Typography variant="caption" className={classes.note}>
                <span>· Cancel anytime</span>
                <span>· Connect in minutes</span>
            </Typography>
        </div>
    );
}

ConnectHero.propTypes = {
    showPricing: PropTypes.bool,
    onViewPricing: PropTypes.func,
    onBrowseIntegrations: PropTypes.func,
};

ConnectHero.defaultProps = {
    showPricing: true,
    onViewPricing: () => {},
    onBrowseIntegrations: () => {},
};

export default ConnectHero;
